import { render, staticRenderFns } from "./SmallProgram.vue?vue&type=template&id=1a07f9f4&scoped=true&"
import script from "./SmallProgram.vue?vue&type=script&lang=js&"
export * from "./SmallProgram.vue?vue&type=script&lang=js&"
import style0 from "./SmallProgram.vue?vue&type=style&index=0&id=1a07f9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07f9f4",
  null
  
)

export default component.exports